<template>
  <Modal :isOpen="isModalOpen" :changeModalState="changeModalState" :modalTitle="`${$t('general.share')} ${label}`"
    id="share__link__modal">
    <div class="social--items--container">
      <ItemsSlider v-if="networks && networks.length > 0" gap="1">
        <ShareNetwork v-for="network in networks" :network="network.network" :key="network.network" :url="URLLink"
          :title="sharingConfig.title" :description="sharingConfig.description" :quote="sharingConfig.quote"
          :hashtags="sharingConfig.hashtags" :twitterUser="sharingConfig.twitterUser" class="social--item flex-column">
          <span :title="`${$t('general.share_via')} ${network.name}`" :style="{ backgroundColor: network.color }"
            class="social__icon__container hover:brightness-110 transition-all duration-150">
            <i v-html="network.icon" class="text-white" />
          </span>
          <span class="mt-2 inline-block text-[0.80rem] md:text-[0.85rem]">{{ network.name }}</span>
        </ShareNetwork>
      </ItemsSlider>

    </div>
    <div class="modal--footer">
      <div class="modal--footer--title flex text-[0.8rem] sm:text-[1rem] md:text-[1.1rem]">
        <strong>{{ $t('general.page_link') }}</strong>
        <span v-show="isCopied" class="text-blue-500 fadeEffect">{{ $t('general.link_copied') }}</span>
      </div>
      <div class="link--zone flex">
        <span v-if="!isInput" @dblclick="isInput = true" class="text-[0.85rem] md:text-[0.9rem]">{{ URLLink }}</span>
        <input v-else type="text" :value="URLLink" disabled readonly class="text-[0.85rem] md:text-[0.9rem] bg-transparent w-[90%] p-0.5"/>
        <button @click="() => copyLink()" :title="$t('general.copy')" aria-label="copy page URL" aria-labelledby="copy page URL">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.3" height="17" viewBox="0 0 512 512">
            <path fill="currentColor" d="M408 432h-32v32H112V136h32v-32H80v392h328v-64z" />
            <path fill="currentColor"
              d="M176 16v384h320V153.373L358.627 16Zm288 352H208V48h104v152h152Zm0-200H344V48h1.372L464 166.627Z" />
          </svg>
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal } from "@/components";
import ItemsSlider from "../generic/ItemsSlider.vue";

export default {
  data() {
    return {
      isCopied: false,
      isInput: false,
    }
  },
  props: {
    label: {
      type: String,
      required: false,
      default: ""
    },
    URLLink: {
      type: String,
      default: "",
      required: true
    },
    isModalOpen: {
      type: Boolean,
      default: false,
      required: true
    },
    changeModalState: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      default: "",
      required: true
    },
    description: {
      type: String,
      default: "",
      required: false
    },
    quote: {
      type: String,
      default: "",
      required: false
    },
    hashtags: {
      type: String,
      default: "",
      required: false
    }
  },
  components: {
    Modal,
    ItemsSlider
  },
  computed: {
    sharingConfig() {
      return {
        title: this.title,
        ...(this.description && {
          description: this.description,
        }),
        ...(this.quote && {
          quote: this.quote,
        }),
        ...(this.hashtags && {
          hashtags: this.hashtags
        })
      };
    },
    networks() {
      return [
        {
          network: "facebook",
          name: this.$t("general.facebook"),
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[21px] h-[21px] sm:w-[24px] sm:h-[24px] md:w-[30px] md:h-[30px]" width="30" height="30" viewBox="0 0 24 24"><path fill="currentColor" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5Z"/></svg>`,
          color: "#1877f2"
        },
        {
          network: "twitter",
          name: 'X',
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[21px] h-[21px] sm:w-[24px] sm:h-[24px] md:w-[30px] md:h-[30px]" width="30" height="30" viewBox="0 0 24 24"><path fill="white" d="M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z"/></svg>`,
          color: "#000000"
        },
        {
          network: "linkedin",
          name: this.$t("general.linkedin"),
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[21px] h-[21px] sm:w-[24px] sm:h-[24px] md:w-[30px] md:h-[30px]" width="30" height="30" viewBox="0 0 24 24"><path fill="currentColor" d="M20.47 2H3.53a1.45 1.45 0 0 0-1.47 1.43v17.14A1.45 1.45 0 0 0 3.53 22h16.94a1.45 1.45 0 0 0 1.47-1.43V3.43A1.45 1.45 0 0 0 20.47 2ZM8.09 18.74h-3v-9h3ZM6.59 8.48a1.56 1.56 0 1 1 0-3.12a1.57 1.57 0 1 1 0 3.12Zm12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.65 1.65 0 0 0 12.85 13a2 2 0 0 0-.1.73v5h-3v-9h3V11a3 3 0 0 1 2.71-1.5c2 0 3.45 1.29 3.45 4.06Z"/></svg>`,
          color: "#007bb5"
        },
        {
          network: "email",
          name: this.$t("general.email_short"),
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[21px] h-[21px] sm:w-[24px] sm:h-[24px] md:w-[30px] md:h-[30px]" width="30" height="30" viewBox="0 0 24 24"><path fill="currentColor" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25a.85.85 0 1 1 .9-1.44L12 11l6.7-4.19a.85.85 0 1 1 .9 1.44z"/></svg>`,
          color: "#333333"
        },
        {
          network: "whatsapp",
          name: this.$t("general.whatsapp"),
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[21px] h-[21px] sm:w-[24px] sm:h-[24px] md:w-[30px] md:h-[30px]" width="30" height="30" viewBox="0 0 24 24"><path fill="currentColor" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z"/></svg>`,
          color: "#25d366"
        },
        {
          network: "telegram",
          name: this.$t("general.telegram"),
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[21px] h-[21px] sm:w-[24px] sm:h-[24px] md:w-[30px] md:h-[30px]" width="30" height="30" viewBox="0 0 32 32"><path fill="currentColor" d="M26.07 3.996a2.974 2.974 0 0 0-.933.223h-.004c-.285.113-1.64.683-3.7 1.547l-7.382 3.109c-5.297 2.23-10.504 4.426-10.504 4.426l.062-.024s-.359.118-.734.375a2.03 2.03 0 0 0-.586.567c-.184.27-.332.683-.277 1.11c.09.722.558 1.155.894 1.394c.34.242.664.355.664.355h.008l4.883 1.645c.219.703 1.488 4.875 1.793 5.836c.18.574.355.933.574 1.207c.106.14.23.257.379.351a1.119 1.119 0 0 0 .246.106l-.05-.012c.015.004.027.016.038.02c.04.011.067.015.118.023c.773.234 1.394-.246 1.394-.246l.035-.028l2.883-2.625l4.832 3.707l.11.047c1.007.442 2.027.196 2.566-.238c.543-.437.754-.996.754-.996l.035-.09l3.734-19.129c.106-.472.133-.914.016-1.343a1.807 1.807 0 0 0-.781-1.047a1.872 1.872 0 0 0-1.067-.27zm-.101 2.05c-.004.063.008.056-.02.177v.011l-3.699 18.93c-.016.027-.043.086-.117.145c-.078.062-.14.101-.465-.028l-5.91-4.531l-3.57 3.254l.75-4.79l9.656-9c.398-.37.265-.448.265-.448c.028-.454-.601-.133-.601-.133l-12.176 7.543l-.004-.02l-5.836-1.965v-.004l-.015-.003a.27.27 0 0 0 .03-.012l.032-.016l.031-.011s5.211-2.196 10.508-4.426c2.652-1.117 5.324-2.242 7.379-3.11a807.312 807.312 0 0 1 3.66-1.53c.082-.032.043-.032.102-.032z"/></svg>`,
          color: "#0088cc"
        },
        {
          network: "sms",
          name: this.$t("general.sms_short"),
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[17px] h-[17px] sm:w-[19px] sm:h-[19px] md:w-[22px] md:h-[22px]" width="22" height="22" viewBox="0 0 512 512"><path fill="currentColor" d="M448 0H64C28.6 0 0 28.6 0 64v256c0 35.4 28.6 64 64 64h128l-42.7 128l192-128H448c35.4 0 64-28.6 64-64V64c0-35.4-28.6-64-64-64zM128 234.7c-23.6 0-42.7-19.1-42.7-42.7s19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7s-19.1 42.7-42.7 42.7zm128 0c-23.6 0-42.7-19.1-42.7-42.7s19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7s-19.1 42.7-42.7 42.7zm128 0c-23.6 0-42.7-19.1-42.7-42.7s19.1-42.7 42.7-42.7s42.7 19.1 42.7 42.7s-19.1 42.7-42.7 42.7z"/></svg>`,
          color: "#333333"
        },
        {
          network: "messenger",
          name: this.$t("general.messenger"),
          icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-[21px] h-[21px] sm:w-[24px] sm:h-[24px] md:w-[30px] md:h-[30px]" width="30" height="30" viewBox="0 0 24 24"><path fill="currentColor" d="M12.001 2c5.633 0 10 4.127 10 9.7c0 5.573-4.367 9.7-10 9.7a10.893 10.893 0 0 1-2.895-.384a.8.8 0 0 0-.534.039l-1.985.876a.8.8 0 0 1-1.123-.707l-.054-1.78a.797.797 0 0 0-.269-.57c-1.945-1.74-3.14-4.258-3.14-7.174c0-5.573 4.366-9.7 10-9.7ZM5.996 14.537c-.282.447.268.951.689.631l3.155-2.394a.6.6 0 0 1 .723 0l2.336 1.75a1.5 1.5 0 0 0 2.17-.4l2.937-4.66c.282-.448-.268-.952-.689-.633l-3.155 2.396a.6.6 0 0 1-.723 0l-2.337-1.75a1.5 1.5 0 0 0-2.169.4l-2.937 4.66Z"/></svg>`,
          color: "#006AFF"
        }
      ];
    }
  },
  watch: {
    isModalOpen: {
      immediate: false,
      handler(val) {
        if (typeof val == "boolean" && !val) {
          this.isCopied = false;
          this.isInput = false;
        }
      }
    }
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.URLLink);
      this.isCopied = true;
    },
  }
};
</script>

<style lang="scss" scoped>
#share__link__modal {
  .social--items--container {
    gap: 1rem;
    flex-wrap: wrap;
    padding: 1.5rem 1rem;

    @media (max-width: 670px) {
      padding: 1rem 0.5rem;
    }

    &,
    .social--item {
      justify-content: center;
      align-content: center;
      text-align: center;
    }

    .social--item {
      padding: 0 0.6rem;
      text-decoration: none;
      row-gap: 0.3rem;

      .social__icon__container {
        border: 1px solid #dbdbdb;
        display: grid;
        place-content: center;
        border-radius: 50%;
        padding: 1rem 1.1rem;
        width: 55px;
        height: 55px;
        margin: 0 auto;

        svg {
          justify-self: center;
          color: #fff;
        }

        @media (max-width: 670px) {
          width: 45px;
          height: 45px;
        }
      }
    }
  }

  .modal--footer {
    border-top: 1px solid #dbdbdb;
    padding: 1rem;

    .modal--footer--title {
      gap: 1rem 0.5rem;
      align-items: center;
    }

    .link--zone {
      align-items: center;
      justify-content: space-between;
      margin-top: 0.5rem;
      background: rgba(165, 139, 101, 0.2);
      padding: 0.6rem 0.6rem;
      border-radius: 0.2rem;
      color: #31363d;
      font-weight: 500;

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 90%;
      }

      button {
        background: none;
        border: none;
        color: inherit;
        font-weight: 600;
        font-size: 1.09rem;
        padding: 0.2rem 0.5rem;
        border-radius: 0.2rem;

        &:active {
          background: rgba(196, 196, 196, 0.4);
        }
      }
    }
  }
}
</style>